import { useContext, useState } from "react";
import { FirebaseAuthContext } from "../../../../../../commons/firebase/FirebaseAuthProvider";
import { useSnackbar } from "notistack";
import {
    browserName,
    browserVersion,
    osName,
    osVersion,
} from "react-device-detect";
import { useIntl } from "react-intl";

// Hook for fetching the courses a player is registered to and the playlists of that course

const useSubmitChallengeDecision = () => {
    const { signedInUser } = useContext(FirebaseAuthContext);
    const intl = useIntl();
    const { enqueueSnackbar } = useSnackbar();

    const savePlayerInputs = async (
        decisionId,
        scoredSceneId,
        playlistId,
        courseId,
        playerNotes
    ) => {
        const idToken = await signedInUser.getIdToken();
        console.log(scoredSceneId);
        fetch("/reg-main/challenge_decisions/submit", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                idToken: idToken,
                challengeDecisionData: {
                    userId: signedInUser.uid,
                    courseId: courseId,
                    playlistId: playlistId,
                    scoredSceneId: scoredSceneId,
                    decisionId: decisionId,
                    playerNotes: playerNotes,
                    closed: false,
                    clientInfo: {
                        browser: browserName,
                        browserVersion: browserVersion,
                        platform: osName,
                        platformVersion: osVersion,
                        screenWidth: window.innerWidth,
                        screenHeight: window.innerHeight,
                    },
                },
            }),
        }).then(async (data) => {
            if (data.status === 200) {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: "app.game.review.content.challenge.decision.submit.success",
                        defaultMessage: "Your suggestion has been submitted!",
                    }),
                    {
                        variant: "success",
                        preventDuplicate: true,
                        autoHideDuration: 5000,
                    }
                );
            } else {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: "app.game.review.content.challenge.decision.submit.failure",
                        defaultMessage:
                            "Something went wrong while submitting your suggestion.",
                    }),
                    {
                        variant: "error",
                        preventDuplicate: true,
                        autoHideDuration: 5000,
                    }
                );
            }
        });
    };

    return { savePlayerInputs };
};

export default useSubmitChallengeDecision;
